export const onlyNumber = (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  limit: number
) => event.target.value.replace(/[^0-9]/g, "").slice(0, limit);
